import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
  Container,
  Chip,
  Divider,
  useTheme,
  Card,
  CardContent,
  IconButton,
  Button,
  Stack,
  alpha,
  Link as MuiLink,
} from '@mui/material';
import {
  Policy as PolicyIcon,
  Security as SecurityIcon,
  ContactSupport as ContactIcon,
  CheckCircle as CheckIcon,
  KeyboardArrowUp as ArrowUpIcon,
  PointOfSale as PosIcon,
  ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const termsContent = `PLEASE READ THESE TERMS CAREFULLY, AS THEY APPLY TO YOUR USE OF https://pos.kaziflex.com (the "Site"). THESE TERMS OF USE (THESE "TERMS") SET FORTH THE LEGALLY BINDING TERMS AND CONDITIONS THAT GOVERN YOUR USE OF THE SITE. BY ACCESSING OR USING THE SITE, YOU ARE ACCEPTING THESE TERMS (ON BEHALF OF YOURSELF OR THE ENTITY THAT YOU REPRESENT), AND YOU REPRESENT AND WARRANT THAT YOU HAVE THE RIGHT, AUTHORITY, AND CAPACITY TO ENTER INTO THESE TERMS (ON BEHALF OF YOURSELF OR THE ENTITY THAT YOU REPRESENT). YOU MAY NOT ACCESS OR USE THE SITE OR ACCEPT THE TERMS IF YOU ARE NOT AT LEAST 18 YEARS OLD. IF YOU DO NOT AGREE WITH ALL OF THE PROVISIONS OF THESE TERMS, DO NOT ACCESS AND/OR USE THE SITE.

The website located at pos.kaziflex.com (the "Site") is a copyrighted work belonging to Kazi Flex LLC ("Company", "us", "our", and "we"). Certain features of the Site may be subject to additional guidelines, terms, or rules, which will be posted on the Site in connection with such features. All such additional terms, guidelines, and rules are incorporated by reference into these Terms.

Definitions
Capitalised terms used in these Terms shall have the following meanings:

"Services": Means the services provided by us which includes the use of the Site

1. Access to the Site
License: Subject to these Terms, Company grants you a non-transferable, non-exclusive, revocable, limited license to use and access the Site solely for your own personal, noncommercial use.

Certain Restrictions: The rights granted to you in these Terms are subject to the following restrictions: (a) you shall not license, sell, rent, lease, transfer, assign, distribute, host, or otherwise commercially exploit the Site, whether in whole or in part, or any content displayed on the Site; (b) you shall not modify, make derivative works of, disassemble, reverse compile or reverse engineer any part of the Site; (c) you shall not access the Site in order to build a similar or competitive website, product, or service; and (d) except as expressly stated herein, no part of the Site may be copied, reproduced, distributed, republished, downloaded, displayed, posted or transmitted in any form or by any means. Unless otherwise indicated, any future release, update, or other addition to functionality of the Site shall be subject to these Terms. All copyright and other proprietary notices on the Site (or on any content displayed on the Site) must be retained on all copies thereof.

Modification: Company reserves the right, at any time, to modify, suspend, or discontinue the Site (in whole or in part) with or without notice to you. You agree that Company will not be liable to you or to any third party for any modification, suspension, or discontinuation of the Site or any part thereof.

Ownership: Excluding any User Content that you may provide (defined below), you acknowledge that all the intellectual property rights, including copyrights, patents, trade marks, and trade secrets, in the Site and its content are owned by Company or Company's suppliers. Neither these Terms (nor your access to the Site) transfers to you or any third party any rights, title or interest in or to such intellectual property rights, except for the limited access rights expressly set forth in Section 2.1. Company and its suppliers reserve all rights not granted in these Terms. There are no implied licenses granted under these Terms.

2. User Content
User Content: "User Content" means any and all information and content that a user submits to, or uses with, the Site (e.g., content in the user's profile or postings). You are solely responsible for your User Content. You assume all risks associated with use of your User Content, including any reliance on its accuracy, completeness or usefulness by others, or any disclosure of your User Content that personally identifies you or any third party. You hereby represent and warrant that your User Content does not violate our Acceptable Use Policy (defined in Section 3.3). You may not represent or imply to others that your User Content is in any way provided, sponsored or endorsed by Company. Since you alone are responsible for your User Content, you may expose yourself to liability if, for example, your User Content violates the Acceptable Use Policy. Company is not obligated to backup any User Content, and your User Content may be deleted at any time without prior notice. You are solely responsible for creating and maintaining your own backup copies of your User Content if you desire.

Acceptable Use Policy: The following terms constitute our "Acceptable Use Policy":

You agree not to use the Site to collect, upload, transmit, display, or distribute any User Content (i) that violates any third-party right, including any copyright, trademark, patent, trade secret, moral right, privacy right, right of publicity, or any other intellectual property or proprietary right, (ii) that is unlawful, harassing, abusive, tortious, threatening, harmful, invasive of another's privacy, vulgar, defamatory, false, intentionally misleading, trade libelous, pornographic, obscene, patently offensive, promotes racism, bigotry, hatred, or physical harm of any kind against any group or individual or is otherwise objectionable, (iii) that is harmful to minors in any way, or (iv) that is in violation of any law, regulation, or obligations or restrictions imposed by any third party.

In addition, you agree not to: (i) upload, transmit, or distribute to or through the Site any computer viruses, worms, or any software intended to damage or alter a computer system or data; (ii) send through the Site unsolicited or unauthorized advertising, promotional materials, junk mail, spam, chain letters, pyramid schemes, or any other form of duplicative or unsolicited messages, whether commercial or otherwise; (iii) use the Site to harvest, collect, gather or assemble information or data regarding other users, including e-mail addresses, without their consent; (iv) interfere with, disrupt, or create an undue burden on servers or networks connected to the Site, or violate the regulations, policies or procedures of such networks; (v) attempt to gain unauthorized access to the Site (or to other computer systems or networks connected to or used together with the Site), whether through password mining or any other means; (vi) harass or interfere with any other user's use and enjoyment of the Site; or (vi) use software or automated agents or scripts to produce multiple accounts on the Site, or to generate automated searches, requests, or queries to (or to strip, scrape, or mine data from) the Site.

Enforcement: We reserve the right (but have no obligation) to review, refuse and/or remove any User Content in our sole discretion, and to investigate and/or take appropriate action against you in our sole discretion if you violate the Acceptable Use Policy or any other provision of these Terms or otherwise create liability for us or any other person. Such action may include removing or modifying your User Content, terminating your Account in accordance with Section 8, and/or reporting you to law enforcement authorities.

3. Code of Conduct
You agree to behave in such a way as to create a safe, supportive environment throughout your use of the Site.

You agree not to engage in any form of harassing, offensive, discriminatory or threatening speech or behavior, including relating to race, gender, sexual orientation, religion or disability. If you witness such behavior, please promptly contact our support team so direct action can be taken.

4. Account Creation and Usage
Account Creation: In order to use certain features of the Site, you must create an account ("Account") and provide certain information about yourself as prompted by the account registration form. You represent and warrant that:

All required registration information you submit is truthful and accurate.
You will maintain the accuracy of such information. You may delete your Account at any time, for any reason by contacting support.

Account Responsibilities: You are responsible for maintaining the confidentiality of your Account login information and are fully responsible for all activities that occur under your Account. You agree to immediately notify Company of any unauthorized use, or suspected unauthorized use of your Account or any other breach of security. Company cannot and will not be liable for any loss or damage arising from your failure to comply with the above requirements.

5. Indemnification
You hereby indemnify to the fullest extent Kazi Flex LLC from and against any and all liabilities, costs, demands, causes of action, damages and expenses arising in any way related to your breach of any of the provisions of these Terms.

6. Term & Termination
Subject to this Section, these Terms will remain in full force and effect while you use the Site. We may suspend or terminate your rights to use the Site (including your Account) at any time for any reason at our sole discretion, including for any use of the Site in violation of these Terms. Upon termination of your rights under these Terms, your Account and right to access and use the Site will terminate immediately. You understand that any termination of your Account may involve deletion of your User Content associated with your Account from our live databases. Company will not have any liability whatsoever to you for any termination of your rights under these Terms, including for termination of your Account or deletion of your User Content.

7. Severability
If any of these Terms are held invalid, illegal or unenforceable by any court or tribunal of competent jurisdiction, it will be severed and the remaining terms will continue in full force and effect as if these Terms had been made without the invalid, illegal or unenforceable terms.

8. Changes to these Terms
We may revise these from time to time to reflect changes in our Services. We encourage you to review these Terms periodically to be informed of any latest changes. Where we consider any changes to these Terms reasonably material, we will notify you prior to such changes becoming effective (to the email you provided during the account creation process or any other means). You agree that by creating an account, with or without notice from us, you consent to the changes to these Terms.

9. Contact Us
You may write to us at support@kaziflex.com for any concerns and requests relating to these Terms, Disclaimers, the Privacy Policy, or our Site and Services.`;

const privacyContent = `Welcome to the website for Flex PoS at https://pos.kaziflex.com (the "Site"). Your privacy is important to us and this Privacy Policy applies to the information collected, stored, and used when you use the Site. Our "Services" mean the services provided by us.

We recognize the importance of privacy as well as the importance of maintaining the confidentiality of personal information. This Privacy Policy applies to all products and services provided by us and sets out how we collect, use and disclose information in relation to users of the Site (however accessed). Please read this Privacy Policy carefully and make sure that you properly understand the provisions. Please do not use our Site if you disagree with any of the terms of this Privacy Policy.

1. Important Information about us and the Site
Kazi Flex LLC is the controller and responsible for your personal data.

If you have any questions about this Privacy Policy or our privacy practices, please contact us via email at support@kaziflex.com.

2. Collection of Information
Your privacy is important to us and we have taken steps to ensure that we do not collect more information from you than is necessary for us to provide you with our Services and to protect your account.

When you create an account on our Site, you may be required to provide us with certain information including but not limited to:

• Your name and email address
• Business information (if applicable)
• Contact details

Together this is referred to as "User Generated Content".

3. Use of Personal Data
We shall use your Personal Data in accordance with this Privacy Policy or as otherwise permitted by law according to where you are located.

Such permitted uses may include the following circumstances:

• Verifying your identity
• Responding to your queries, feedback, claims or disputes
• Carrying out audience measurement, marketing and analytics to help us improve our Services
• Implementing security measures to protect our Services, your account and data processed for our Services against fraud and other security incidents

4. Rights Regarding Personal Data
Under the applicable laws, you may have the rights of access to Personal Data held by us and other rights, including the right to correction of false or misleading data.

If you have any questions regarding this Privacy Policy or if you wish to access or correct your Personal Data as a user of the Site, you may send your request to support@kaziflex.com.

You have the right at any time to prevent us from contacting you for marketing purposes. When we send a promotional communication to a user, the user can opt out of further promotional communications by following the unsubscribe instructions provided in each promotional e-mail. Please note that notwithstanding the promotional preferences you indicate by either unsubscribing or opting out in the settings of the Site, we may continue to send you administrative emails including, for example, periodic updates to our Privacy Policy.

5. Security Measures
We have put in place appropriate security measures to prevent your Personal Data from being accidentally lost, used or accessed in an unauthorised way, altered or disclosed. In addition, we limit access to your Personal Data to those employees, agents, contractors and other third parties who have a business need to know. They will only process your Personal Data on our instructions and they are subject to a duty of confidentiality. We also employ commercially reasonable security methods to prevent unauthorized access to the Site, to maintain data accuracy and to ensure the correct use of the information we hold.

We have put in place procedures to deal with any suspected personal data breach and will notify you and any applicable regulator of a breach where we are legally required to do so.

We recommend that you do not divulge your password to anyone. Our personnel will never ask you for your password in an unsolicited phone call or in an unsolicited email. If you share a computer with others, you should not choose to save your log-in information (e.g., user ID and password) on that shared computer. Remember to sign out of your account and close your browser window when you have finished your session.

6. Changes To This Privacy Policy
We may update this Privacy Policy from time to time in response to changing legal, technical or business developments. When we update our Privacy Policy, we will take appropriate measures to inform you, consistent with the significance of the changes we make. We will obtain your consent to any material Privacy Policy changes if and where this is required by applicable data protection laws. Any changes to this Privacy Policy will be communicated by us posting an amended Privacy Policy on the Site. Once posted on the Site, the new Privacy Policy will be effective immediately. You can see when this Privacy Notice was last updated by checking the "last updated" date displayed at the top of this Privacy Notice.

7. Contact Us
You may write to us at support@kaziflex.com for any privacy concerns and requests relating to these Terms, Disclaimers, the Privacy Policy, or our Site and Services.`;

export default function TermsAndPrivacy() {
  const [tab, setTab] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();

  useEffect(() => {
    const queryTab = new URLSearchParams(location.search).get('tab');
    if (queryTab === 'privacy') {
      setTab(1);
    }
  }, [location.search]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const keyHighlights = [
    {
      icon: <CheckIcon />,
      title: "Safe & Secure",
      description: "Your data is protected with enterprise-grade security"
    },
    {
      icon: <PolicyIcon />,
      title: "Transparent Terms",
      description: "Clear and fair terms with no hidden clauses"
    },
    {
      icon: <ContactIcon />,
      title: "Support Ready",
      description: "Our team is here to help with any questions"
    }
  ];

  return (
    <>
      <Helmet>
        <title>{tab === 0 ? 'Terms and Conditions' : 'Privacy Policy'} | Flex PoS</title>
        <meta name="description" content={tab === 0 ? 'Read the terms and conditions for using Flex PoS services.' : 'Learn how Flex PoS collects, uses, and protects your personal information.'} />
      </Helmet>

      <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
        {/* Navigation */}
        <Box
          component="nav"
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 1100,
            bgcolor: 'background.paper',
            borderBottom: '1px solid',
            borderColor: 'divider',
            backdropFilter: 'blur(8px)',
            backgroundColor: alpha(theme.palette.background.paper, 0.95)
          }}
        >
          <Container maxWidth="lg">
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 2 }}>
              {/* Logo */}
              <Box
                component={Link}
                to="/"
                sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
              >
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: 2.5,
                    background: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mr: 1.5,
                    boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)',
                  }}
                >
                  <PosIcon sx={{ color: 'white', fontSize: 24 }} />
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 800,
                    letterSpacing: '-0.02em',
                    background: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                >
                  Flex PoS
                </Typography>
              </Box>

              {/* Nav Links */}
              <Stack direction="row" spacing={1} alignItems="center">
                <Button component={Link} to="/login" sx={{ fontWeight: 600 }}>
                  Sign In
                </Button>
                <Button
                  component={Link}
                  to="/register"
                  variant="contained"
                  sx={{
                    fontWeight: 600,
                    background: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%)',
                    }
                  }}
                >
                  Get Started
                </Button>
              </Stack>
            </Box>
          </Container>
        </Box>

        {/* Hero Section */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 50%, #EC4899 100%)',
            color: 'white',
            py: { xs: 6, md: 8 },
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          {/* Background Pattern */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              opacity: 0.1,
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            }}
          />
          <Container maxWidth="lg" sx={{ position: 'relative' }}>
            <Button
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate('/')}
              sx={{
                color: 'white',
                mb: 3,
                '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
              }}
            >
              Back to Home
            </Button>
            <Typography
              variant="h2"
              sx={{
                fontWeight: 800,
                fontSize: { xs: '2rem', md: '3rem' },
                mb: 2,
                letterSpacing: '-0.02em'
              }}
            >
              Legal Information
            </Typography>
            <Typography
              variant="h6"
              sx={{ opacity: 0.9, fontWeight: 400, maxWidth: 600, mb: 4 }}
            >
              Understanding your rights and our commitment to protecting your privacy
            </Typography>

            {/* Key Highlights */}
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={3}>
              {keyHighlights.map((highlight, index) => (
                <Card
                  key={index}
                  sx={{
                    bgcolor: 'rgba(255, 255, 255, 0.15)',
                    backdropFilter: 'blur(10px)',
                    color: 'white',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    flex: 1,
                    textAlign: 'center'
                  }}
                >
                  <CardContent sx={{ py: 3 }}>
                    <Box sx={{ color: 'white', mb: 1, '& svg': { fontSize: 32 } }}>
                      {highlight.icon}
                    </Box>
                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                      {highlight.title}
                    </Typography>
                    <Typography variant="body2" sx={{ opacity: 0.9 }}>
                      {highlight.description}
                    </Typography>
                  </CardContent>
                </Card>
              ))}
            </Stack>
          </Container>
        </Box>

        {/* Main Content */}
        <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
          {/* Navigation Tabs */}
          <Paper
            sx={{
              mb: 4,
              borderRadius: 3,
              overflow: 'hidden'
            }}
          >
            <Tabs
              value={tab}
              onChange={(_, v) => setTab(v)}
              variant="fullWidth"
              sx={{
                bgcolor: 'grey.50',
                '& .MuiTab-root': {
                  py: 2.5,
                  fontSize: '1rem',
                  fontWeight: 600,
                  textTransform: 'none',
                },
                '& .Mui-selected': {
                  color: 'primary.main',
                },
                '& .MuiTabs-indicator': {
                  height: 3,
                }
              }}
            >
              <Tab
                icon={<PolicyIcon />}
                label="Terms and Conditions"
                iconPosition="start"
              />
              <Tab
                icon={<SecurityIcon />}
                label="Privacy Policy"
                iconPosition="start"
              />
            </Tabs>
          </Paper>

          {/* Content Section */}
          <Paper sx={{ borderRadius: 3, overflow: 'hidden' }}>
            {/* Content Header */}
            <Box
              sx={{
                background: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)',
                color: 'white',
                p: { xs: 3, md: 4 }
              }}
            >
              <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
                {tab === 0 ? 'Terms and Conditions' : 'Privacy Policy'}
              </Typography>
              <Typography variant="body1" sx={{ opacity: 0.9, mb: 2 }}>
                {tab === 0
                  ? 'Please read these terms carefully as they govern your use of Flex PoS services'
                  : 'Learn how we collect, use, and protect your personal information'
                }
              </Typography>
              <Chip
                label={`Last Updated: ${new Date().toLocaleDateString()}`}
                size="small"
                sx={{
                  bgcolor: 'rgba(255, 255, 255, 0.2)',
                  color: 'white',
                  fontWeight: 500
                }}
              />
            </Box>

            {/* Content Body */}
            <Box sx={{ p: { xs: 3, md: 4 } }}>
              <Box
                sx={{
                  maxHeight: 500,
                  overflowY: 'auto',
                  pr: 2,
                  '&::-webkit-scrollbar': {
                    width: '8px',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: '#f1f1f1',
                    borderRadius: '4px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: theme.palette.primary.main,
                    borderRadius: '4px',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: theme.palette.primary.dark,
                  },
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    whiteSpace: 'pre-line',
                    fontSize: '0.95rem',
                    lineHeight: 1.8,
                    color: 'text.secondary'
                  }}
                >
                  {tab === 0 ? termsContent : privacyContent}
                </Typography>
              </Box>
            </Box>

            {/* Content Footer */}
            <Divider />
            <Box sx={{ p: 3, bgcolor: 'grey.50', textAlign: 'center' }}>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Have questions about our {tab === 0 ? 'terms' : 'privacy policy'}?
              </Typography>
              <Button
                variant="outlined"
                startIcon={<ContactIcon />}
                onClick={() => navigate('/contact')}
                sx={{ mt: 1 }}
              >
                Contact Support
              </Button>
            </Box>
          </Paper>
        </Container>

        {/* Footer */}
        <Box
          component="footer"
          sx={{
            bgcolor: '#0F172A',
            color: 'white',
            py: 4,
            mt: 'auto'
          }}
        >
          <Container maxWidth="lg">
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 2
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box
                  sx={{
                    width: 36,
                    height: 36,
                    borderRadius: 2,
                    background: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mr: 1.5
                  }}
                >
                  <PosIcon sx={{ color: 'white', fontSize: 20 }} />
                </Box>
                <Typography variant="body2" sx={{ color: 'grey.500' }}>
                  © {new Date().getFullYear()} Flex PoS. All rights reserved.
                </Typography>
              </Box>
              <Typography variant="body2" sx={{ color: 'grey.500' }}>
                Developed by{' '}
                <MuiLink
                  href="https://www.kaziflex.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: 'primary.light', fontWeight: 600, textDecoration: 'none' }}
                >
                  Kazi Flex LLC
                </MuiLink>
              </Typography>
            </Box>
          </Container>
        </Box>

        {/* Back to Top Button */}
        <IconButton
          onClick={scrollToTop}
          sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            zIndex: 1000,
            bgcolor: 'primary.main',
            color: 'white',
            boxShadow: 4,
            '&:hover': {
              bgcolor: 'primary.dark',
              transform: 'scale(1.1)',
            },
            transition: 'all 0.2s ease-in-out',
          }}
        >
          <ArrowUpIcon />
        </IconButton>
      </Box>
    </>
  );
}
